if (!window.refreshCartSuggestions) {
  window.refreshCartSuggestions = () => {
    const currentSuggestions =
      document.getElementById('AjaxCartSuggestions');

    if (!currentSuggestions) {
      return Promise.resolve();
    }

    return fetch(
      `?section_id=drawer-cart&_=${Date.now()}`,
      {
        cache: 'no-store'
      }
    )
      .then(response => response.text())
      .then(text => {
        const parsedHTML =
          new DOMParser().parseFromString(
            text,
            'text/html'
          );

        const updatedSuggestions =
          parsedHTML.getElementById(
            'AjaxCartSuggestions'
          );

        if (updatedSuggestions) {
          currentSuggestions.innerHTML =
            updatedSuggestions.innerHTML;
        } else {
          currentSuggestions.innerHTML = '';
        }
      })
      .catch(error => {
        console.error(
          'Unable to refresh cart suggestions:',
          error
        );
      });
  };
}


/* ==========================================
   Keep cart suggestions synced with cart
========================================== */

if (!window.cartSuggestionsObserverInitialized) {
  window.cartSuggestionsObserverInitialized = true;

  let suggestionsRefreshTimer = null;
  let lastObservedCartCount = null;

  const getCartCount = () => {
    const countElement =
      document.querySelector(
        '[data-header-cart-count]'
      );

    if (!countElement) {
      return null;
    }

    return countElement.textContent.trim();
  };

  const scheduleSuggestionsRefresh = () => {
    clearTimeout(suggestionsRefreshTimer);

    suggestionsRefreshTimer = setTimeout(() => {
      window.refreshCartSuggestions();
    }, 100);
  };

  const initializeSuggestionsObserver = () => {
    lastObservedCartCount = getCartCount();

    const observer = new MutationObserver(() => {
      const currentCartCount = getCartCount();

      if (
        currentCartCount !== null &&
        currentCartCount !== lastObservedCartCount
      ) {
        lastObservedCartCount = currentCartCount;
        scheduleSuggestionsRefresh();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener(
      'DOMContentLoaded',
      initializeSuggestionsObserver
    );
  } else {
    initializeSuggestionsObserver();
  }
}

if (typeof CartForm !== 'function') {
  class CartForm extends HTMLElement {
    constructor() {
      super();
      this.ajaxifyCartItems();
    }

    ajaxifyCartItems() {
      this.form = this.querySelector('form');

      this.querySelectorAll('[data-js-cart-item]').forEach(item => {
        const remove = item.querySelector('.remove');

        if (remove) {
          remove.dataset.href = remove.getAttribute('href');
          remove.setAttribute('href', '');

          remove.addEventListener('click', event => {
            event.preventDefault();
            this.updateCartQty(item, 0);
          });
        }

        const qty = item.querySelector('.qty');

        if (qty) {
          qty.addEventListener(
            'input',
            debounce(event => {
              event.preventDefault();
              event.target.blur();

              const quantity = Math.max(
                0,
                parseInt(qty.value, 10) || 0
              );

              this.updateCartQty(item, quantity);
            }, 500)
          );

          qty.addEventListener('click', event => {
            event.target.select();
          });
        }
      });
    }

    updateCartQty(item, newQty) {
      let alert = null;

      const quantity = Math.max(
        0,
        parseInt(newQty, 10) || 0
      );

      this.form.classList.add('processing');

      if (quantity === 0) {
        item.classList.add('processing');
      }

      const existingAlert = this.querySelector('.alert');

      if (existingAlert) {
        existingAlert.remove();
      }

      const body = JSON.stringify({
        line: parseInt(item.dataset.line, 10),
        quantity
      });

      fetch(KROWN.settings.routes.cart_change_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/javascript'
        },
        body
      })
        .then(response => response.json())
        .then(response => {
          if (response.status === 422) {
            alert = document.createElement('span');
            alert.classList.add('alert', 'alert--error');

            if (typeof response.description === 'string') {
              alert.innerHTML = response.description;
            } else {
              alert.innerHTML = response.message;
            }
          }

          return fetch('?section_id=helper-cart');
        })
        .then(response => response.text())
        .then(text => {
          const sectionInnerHTML =
            new DOMParser().parseFromString(text, 'text/html');

          const updatedCartForm =
            sectionInnerHTML.getElementById('AjaxCartForm');

          const updatedCartSubtotal =
            sectionInnerHTML.getElementById(
              'AjaxCartSubtotal'
            );

          if (!updatedCartForm || !updatedCartSubtotal) {
            throw new Error(
              'Updated cart markup could not be found.'
            );
          }

          const cartItems =
            document.getElementById('AjaxCartForm');

          cartItems.innerHTML = updatedCartForm.innerHTML;
          cartItems.ajaxifyCartItems();

          const cartCount =
            cartItems.querySelector('[data-cart-count]');

          const cartTotal =
            cartItems.querySelector('[data-cart-total]');

          document
            .querySelectorAll('[data-header-cart-count]')
            .forEach(element => {
              if (cartCount) {
                element.textContent = cartCount.textContent;
              }
            });

          document
            .querySelectorAll('[data-header-cart-total]')
            .forEach(element => {
              if (cartTotal) {
                element.textContent = cartTotal.textContent;
              }
            });

          if (alert !== null) {
            this.form.prepend(alert);
          }

          document.getElementById(
            'AjaxCartSubtotal'
          ).innerHTML = updatedCartSubtotal.innerHTML;

          return window.refreshCartSuggestions();
        })
        .then(() => {
          const event = new Event('cart-updated');
          this.dispatchEvent(event);
        })
        .catch(error => {
          console.error(error);

          const errorAlert =
            document.createElement('span');

          errorAlert.classList.add(
            'alert',
            'alert--error'
          );

          errorAlert.textContent =
            KROWN.settings.locales.cart_general_error;

          this.form.prepend(errorAlert);
        })
        .finally(() => {
          this.form.classList.remove('processing');
        });
    }
  }

  if (
    typeof customElements.get('cart-form') === 'undefined'
  ) {
    customElements.define('cart-form', CartForm);
  }
}


if (typeof CartProductQuantity !== 'function') {
  class CartProductQuantity extends HTMLElement {
    constructor() {
      super();

      const minusButton =
        this.querySelector('.qty-minus');

      const plusButton =
        this.querySelector('.qty-plus');

      if (minusButton) {
        minusButton.addEventListener(
          'click',
          this.changeCartInput.bind(this)
        );
      }

      if (plusButton) {
        plusButton.addEventListener(
          'click',
          this.changeCartInput.bind(this)
        );
      }
    }

    changeCartInput() {
      setTimeout(() => {
        const item = this.closest(
          '[data-js-cart-item]'
        );

        const input = this.querySelector('.qty');

        if (!item || !input) {
          return;
        }

        const quantity = Math.max(
          0,
          parseInt(input.value, 10) || 0
        );

        const cartForm =
          document.getElementById('AjaxCartForm');

        if (cartForm) {
          cartForm.updateCartQty(item, quantity);
        }
      }, 50);
    }
  }

  if (
    typeof customElements.get(
      'cart-product-quantity'
    ) === 'undefined'
  ) {
    customElements.define(
      'cart-product-quantity',
      CartProductQuantity
    );
  }
}


// Method for apps to refresh the cart.

window.refreshCart = () => {
  return fetch('?section_id=helper-cart')
    .then(response => response.text())
    .then(text => {
      const sectionInnerHTML =
        new DOMParser().parseFromString(text, 'text/html');

      const updatedCartForm =
        sectionInnerHTML.getElementById('AjaxCartForm');

      const updatedCartSubtotal =
        sectionInnerHTML.getElementById(
          'AjaxCartSubtotal'
        );

      if (!updatedCartForm || !updatedCartSubtotal) {
        throw new Error(
          'Updated cart markup could not be found.'
        );
      }

      const cartItems =
        document.getElementById('AjaxCartForm');

      cartItems.innerHTML = updatedCartForm.innerHTML;
      cartItems.ajaxifyCartItems();

      const cartCount =
        cartItems.querySelector('[data-cart-count]');

      const cartTotal =
        cartItems.querySelector('[data-cart-total]');

      document
        .querySelectorAll('[data-header-cart-count]')
        .forEach(element => {
          if (cartCount) {
            element.textContent = cartCount.textContent;
          }
        });

      document
        .querySelectorAll('[data-header-cart-total]')
        .forEach(element => {
          if (cartTotal) {
            element.textContent = cartTotal.textContent;
          }
        });

      document.getElementById(
        'AjaxCartSubtotal'
      ).innerHTML = updatedCartSubtotal.innerHTML;

      return window.refreshCartSuggestions();
    })
    .then(() => {
      const cartSidebar = document.querySelector(
        '[data-js-site-cart-sidebar]'
      );

      if (cartSidebar) {
        cartSidebar.show();
      }

      const cartRecommendations =
        document.querySelector(
          'cart-recommendations'
        );

      if (
        cartRecommendations &&
        typeof cartRecommendations.generateRecommendations ===
          'function'
      ) {
        cartRecommendations.innerHTML = '';
        cartRecommendations.generateRecommendations();
      }
    })
    .catch(error => {
      console.error('Unable to refresh cart:', error);
    });
};